import { OTP_VERIFICATION_COMPLETED } from '../../config/types'

export default function (state = {}, action) {
    switch (action.type) {
        case OTP_VERIFICATION_COMPLETED:
            return { ...state, otpVerificationStatus: action.payload }
        default:
            return state;
    }
}